import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { themes } from '@storybook/theming';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Button } from '../button';

export const meta = {
  argTypes: {
    appearance: { table: { disable: true } },
    buttonType: { table: { disable: true } },
    disabled: { table: { disable: true } },
    formId: { table: { disable: true } },
    href: { table: { disable: true } },
    iconEnd: { table: { disable: true } },
    iconStart: { table: { disable: true } },
    palette: { table: { disable: true } },
    rel: { table: { disable: true } },
    target: { table: { disable: true } },
    width: { table: { disable: true } },
  },
  args: {
    appearance: '',
    buttonType: '',
    disabled: false,
    formId: '',
    href: '',
    iconEnd: '',
    iconStart: '',
    palette: '',
    rel: '',
    target: '',
    width: '',
  },
  decorators: [
    (story: PartialStoryFn, { args: { palette } }: StoryContext) =>
      html`
        <style type="text/css">
          .sbdocs-preview, .sb-show-main {
            ${palette === 'inverse' ? `background: ${themes.dark?.appBg}` : ''};
          }
        </style>
        ${story()}
      `,
  ],
  title: 'Components/Button/',
};

interface Story {
  appearance: Button['appearance'];
  buttonType: Button['buttonType'];
  disabled: Button['disabled'];
  formId: Button['formId'];
  href: Button['href'];
  iconEnd: Button['iconEnd'];
  iconStart: Button['iconStart'];
  palette: Button['palette'];
  rel: Button['rel'];
  target: Button['target'];
  width: Button['width'];
}

export const story = ({
  appearance,
  buttonType,
  disabled,
  formId,
  href,
  iconEnd,
  iconStart,
  palette,
  rel,
  target,
  width,
}: Partial<Story>) => html`
  <abds-button
    appearance="${ifDefined(appearance || undefined)}"
    button-type="${ifDefined(buttonType || undefined)}"
    disabled="${ifDefined(disabled || undefined)}"
    form-id="${ifDefined(formId || undefined)}"
    href="${ifDefined(href || undefined)}"
    icon-end="${ifDefined(iconEnd || undefined)}"
    icon-start="${ifDefined(iconStart || undefined)}"
    palette="${ifDefined(palette || undefined)}"
    rel="${ifDefined(rel || undefined)}"
    target="${ifDefined(target || undefined)}"
    width="${ifDefined(width || undefined)}"
  >
    ${href ? 'Link text' : 'Button text'}
  </abds-button>
`;

export default { meta, story };
